"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M14 18V5.294L2.706 6.824V18H14zM2.706 20v9.412L14 31.529V20H2.706zM16 20v11.882l16.941 3.177V20H16zm16.941-2V2.941L16 5.059V18h16.941z" })
);

